import React from 'react'

const Breadcrumb = () => {
  return (
    <section className="breadcrumb-area breadcrumb-bg" style={{ backgroundImage: 'url("../img/bg/breadcrumb_bg.jpg")' }}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="breadcrumb-content">
              <h2 className="title"><span>Services</span></h2>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Breadcrumb